module.exports = __webpack_public_path__ + "img/picture_kqmj.a6408a09.png";